export const AutoFocus = {
	mounted(el: HTMLElement): void {
		// console.log('el to focus', el)
		el.focus();
	},
};
